/**
 * Reserved enum filter value when the user selects the optional “empty / unset” row in AtomTable.
 * Serialized to `{ field: { isNull: true } }` in find parameters. Do not use as a real enum value.
 */
export const ATOM_TABLE_ENUM_FILTER_EMPTY = "__atomTableEnumEmpty__" as const;

export function isAtomTableEnumFilterEmptyValue(
  value: string | undefined,
): value is typeof ATOM_TABLE_ENUM_FILTER_EMPTY {
  return value === ATOM_TABLE_ENUM_FILTER_EMPTY;
}
